
import { BaseConverter } from "./base.converter";
import { LocationDto } from "../dtos/location.dto";
import { Location } from "../models/location.model";

export class LocationConverter extends BaseConverter<Location, LocationDto> {  
    modelToDto(model: Location): LocationDto {
        return new LocationDto(
            model.fullAddress,
            model.city, 
            model.country,
            model.latitude,
            model.longitude
        )
    }
    dtoToModel(dto: LocationDto): Location {
        return new Location(
            dto.fullAddress,
            dto.city,
            dto.country,
            dto.latitude,           
            dto.longitude
        )
    }   

}